import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface HowItWorksStepProps {
  number: number;
  titleKey: string;
  descKey: string;
  featureKey: string;
  featureIcon: LucideIcon;
  mockup: ReactNode;
  mockupMaxWidth: 'sm' | 'md';
  reverse?: boolean;
}

export default function HowItWorksStep({
  number,
  titleKey,
  descKey,
  featureKey,
  featureIcon: Icon,
  mockup,
  mockupMaxWidth,
  reverse = false,
}: HowItWorksStepProps) {
  const { t } = useTranslation();
  const maxWidthClass = mockupMaxWidth === 'sm' ? 'max-w-sm' : 'max-w-md';

  return (
    <div className="landing-fade-up grid items-center gap-8 lg:grid-cols-2 lg:gap-16">
      <div className={reverse ? 'lg:order-2' : ''}>
        <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-primary text-lg font-bold text-white">
          {number}
        </div>
        <h3 className="mb-3 text-2xl font-heading text-foreground">{t(titleKey)}</h3>
        <p className="text-muted-foreground leading-relaxed">{t(descKey)}</p>
        <div className="mt-4 flex items-center gap-2 text-sm text-primary">
          <Icon className="h-4 w-4" />
          <span>{t(featureKey)}</span>
        </div>
      </div>
      <div className={`mx-auto w-full ${maxWidthClass} ${reverse ? 'lg:order-1' : ''} lg:mx-0`}>
        {mockup}
      </div>
    </div>
  );
}
